module.exports = __webpack_public_path__ + "img/coinbankB22.a17d3f10.jpg";